module.exports = __webpack_public_path__ + "img/flot7.fe99220b.svg";